/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const GlobalPermMapParser = /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['can_add_users', codecBoolean],
    ['can_create_courses', codecBoolean],
    ['can_manage_site_users', codecBoolean],
    ['can_search_users', codecBoolean],
    ['can_impersonate_users', codecBoolean],
    ['can_manage_lti_providers', codecBoolean],
    ['can_delete_community_library_items', codecBoolean],
    ['can_list_hidden_tenants', codecBoolean],
    ['can_manage_pearson_templates', codecBoolean],
    ['can_view_community_library_items', codecBoolean],
    ['can_view_all_community_library_items', codecBoolean],
    ['can_create_community_library_items', codecBoolean],
    ['is_admin', codecBoolean],
    ['can_see_teacher_announcements', codecBoolean],
    ['can_manage_sso_providers', codecBoolean],
    ['can_manage_site_settings', codecBoolean],
    ['can_manage_background_jobs', codecBoolean],
    ['can_create_tenant', codecBoolean],
    ['can_create_courses_for_other_tenants', codecBoolean],
    ['can_see_other_tenant_statistics', codecBoolean],
    ['can_search_users_other_tenant', codecBoolean],
    ['can_skip_payment', codecBoolean],
    ['can_edit_pricing', codecBoolean],
    ['can_see_all_transactions', codecBoolean],
    ['can_edit_coupons', codecBoolean],
    ['can_see_coupons', codecBoolean],
    ['can_use_snippets', codecBoolean],
    ['can_edit_own_info', codecBoolean],
    ['can_edit_own_password', codecBoolean],
    ['can_view_not_started_autotest_results', codecBoolean],
    ['can_see_other_tenant_oauth_providers', codecBoolean],
    ['can_login_outside_system', codecBoolean],
    ['can_login_outside_lti', codecBoolean],
    ['can_login_outside_sso', codecBoolean],
    ['can_manage_quarantined_registrations', codecBoolean],
]));
export class GlobalPermMap extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return GlobalPermMapParser.decode(input).map(res => new GlobalPermMap(res));
    }
    static unsafeDecode(input) {
        return GlobalPermMap.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return GlobalPermMapParser.encode(data);
    }
    static schema() {
        return GlobalPermMapParser.schema();
    }
}
